/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./save-button.vue?vue&type=template&id=6d68a3d0&scoped=true&"
import script from "./save-button.vue?vue&type=script&lang=js&"
export * from "./save-button.vue?vue&type=script&lang=js&"
import style0 from "./save-button.vue?vue&type=style&index=0&id=6d68a3d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d68a3d0",
  null
  
)

export default component.exports